import { AxiosResponse } from 'axios'
import { http } from '@/core/realisations/Http.realisation'

import {
    ChangeCashPaymentStatusPayload,
    GetCashPaymentStatusParams,
    GetCashPaymentStatusResponse,
    GetCashPaymentStatusByInvoiceResponse
} from '@/new-services/types/cash'

type ApiGetCashPaymentStatusResponse = Promise<AxiosResponse<GetCashPaymentStatusResponse>>
type ApiGetCashPaymentStatusByInvoiceResponse = Promise<AxiosResponse<GetCashPaymentStatusByInvoiceResponse>>
type ApiChangeCashPaymentStatusResponse = Promise<AxiosResponse<void>>
type ApiExportCashPaymentStatusesResponse = Promise<AxiosResponse<any>>

export function getCashPaymentStatus(params: GetCashPaymentStatusParams): ApiGetCashPaymentStatusResponse {
    return http.get('/dispatcher/api/cash-payment-status', { params })
}

export function getCashPaymentStatusByInvoice(invoiceId: number): ApiGetCashPaymentStatusByInvoiceResponse {
    return http.get(`/dispatcher/api/cash-payment-status/${invoiceId}/invoice`)
}

export function changeCashPaymentStatus(payload: ChangeCashPaymentStatusPayload): ApiChangeCashPaymentStatusResponse {
    return http.post('/dispatcher/api/cash-payment-status', payload)
}

export function exportCashPaymentStatuses(params: GetCashPaymentStatusParams): ApiExportCashPaymentStatusesResponse {
    return http.get('/dispatcher/api/cash-payment-status/export', { params, responseType: 'blob' })
}

export default {
    getCashPaymentStatus,
    getCashPaymentStatusByInvoice,
    changeCashPaymentStatus,
    exportCashPaymentStatuses,
}
